/** Keep in sync with netlify/functions/lib/mqtt-gateway-config.js */
export const MQTT_BROKER_HOST_HINT =
  process.env.REACT_APP_MQTT_BROKER_HOST || '34.60.154.225';
export const DEFAULT_MQTT_PORT = 1883;

export const emptyMqttConfig = () => ({
  host: MQTT_BROKER_HOST_HINT,
  port: DEFAULT_MQTT_PORT,
  username: '',
  password: '',
  useTLS: false,
});

/** TBMQ credentials from gateway row — port defaults to 1883 like gateway-mqtt-admin. */
export const getMqttConfigFromGateway = (gateway) => {
  if (!gateway?.tbmq_username || !gateway?.tbmq_password) {
    return emptyMqttConfig();
  }

  return {
    host: gateway.mqtt_broker_host || MQTT_BROKER_HOST_HINT,
    port: Number(gateway.mqtt_broker_port) || DEFAULT_MQTT_PORT,
    username: gateway.tbmq_username,
    password: gateway.tbmq_password,
    useTLS: false,
  };
};

export const pickGatewayForMqttConnect = (gateways = []) => {
  if (!gateways.length) return null;
  return gateways.find((g) => g.tbmq_username && g.tbmq_password) || null;
};

export const getMqttConfigFromGateways = (gateways = []) => {
  const gateway = pickGatewayForMqttConnect(gateways);
  if (!gateway) return emptyMqttConfig();
  return getMqttConfigFromGateway(gateway);
};

export const isMqttConfigComplete = (config) => (
  !!config?.host?.trim()
  && config?.port != null
  && !!config?.username?.trim()
  && !!config?.password
);

/** Strip secrets before persisting pipeline mqtt_config */
export const mqttConfigForStorage = (config) => ({
  host: config?.host ?? '',
  port: config?.port != null ? Number(config.port) : DEFAULT_MQTT_PORT,
  useTLS: !!config?.useTLS,
});

/** MQTT publish topic for a KGateway node (matches backend + ConfigPanel). */
export const getGatewayMqttTopic = (gatewayData = {}) => {
  const explicit = (gatewayData.mqtt_topic || gatewayData.topic || '').trim();
  if (explicit) return explicit;
  const macRaw = gatewayData.mac_address || gatewayData.gateway_mac_hex || '';
  const mac = String(macRaw).replace(/[^0-9A-Fa-f]/g, '').toUpperCase();
  return mac ? `kbeacon/publish/${mac}` : '';
};

/** Subscribe to all MQTT / gateway input topics used by the current canvas. */
export async function subscribeFlowInputTopics(nodes, apiBase) {
  const topics = new Set();
  for (const node of nodes || []) {
    const data = node.data || {};
    const nodeType = data.nodeType;
    if (nodeType === 'mqttInput' && data.topic) {
      topics.add(data.topic);
    }
    if (nodeType === 'kGateway' || node.type === 'gateway') {
      const topic = getGatewayMqttTopic(data);
      if (topic) topics.add(topic);
    }
  }
  await Promise.all(
    [...topics].map((topic) =>
      fetch(`${apiBase}/mqtt/subscribe`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ topic, qos: 0 }),
      }).catch(() => null),
    ),
  );
  return topics;
};
